(function(){
  function init(scope){
    scope.querySelectorAll('[data-cala-product]').forEach(function(root){
      if(root.dataset.ready)return;
      root.dataset.ready='true';
      var q=function(selector){return root.querySelector(selector)};
      var stage=q('[data-cala-stage]');
      var reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
      var frame=0;
      if(stage){
        stage.addEventListener('pointermove',function(event){
          if(reduced.matches||event.pointerType==='touch')return;
          var rect=stage.getBoundingClientRect();
          var x=Math.max(-1,Math.min(1,(event.clientX-rect.left)/rect.width*2-1));
          var y=Math.max(-1,Math.min(1,(event.clientY-rect.top)/rect.height*2-1));
          cancelAnimationFrame(frame);
          frame=requestAnimationFrame(function(){stage.style.setProperty('--cala-ry',x.toFixed(3));stage.style.setProperty('--cala-rx',y.toFixed(3));});
        });
        stage.addEventListener('pointerleave',function(){stage.style.removeProperty('--cala-ry');stage.style.removeProperty('--cala-rx')});
      }

      var fan=q('[data-cala-fan]');
      var fanCards=root.querySelectorAll('[data-cala-fan-card]');
      function selectFanCard(selected){
        fanCards.forEach(function(card){var active=card===selected;card.classList.toggle('is-selected',active);card.setAttribute('aria-pressed',String(active))});
        if(fan)fan.classList.add('has-selection');
      }
      function clearFan(){
        fanCards.forEach(function(card){card.classList.remove('is-selected');card.setAttribute('aria-pressed','false')});
        if(fan)fan.classList.remove('has-selection');
      }
      fanCards.forEach(function(card){
        card.addEventListener('pointerenter',function(event){if(event.pointerType!=='touch')selectFanCard(card)});
        card.addEventListener('focus',function(){selectFanCard(card)});
        card.addEventListener('click',function(){selectFanCard(card)});
      });
      if(fan){
        fan.addEventListener('pointerleave',function(){if(!fan.contains(document.activeElement))clearFan()});
        fan.addEventListener('focusout',function(event){if(!fan.contains(event.relatedTarget))clearFan()});
        fan.addEventListener('keydown',function(event){if(event.key==='Escape')clearFan()});
      }

      var packStage=q('[data-cala-pack-stage]');
      if(packStage){
        packStage.addEventListener('pointermove',function(event){
          if(reduced.matches||event.pointerType==='touch')return;
          var rect=packStage.getBoundingClientRect();
          var x=Math.max(-1,Math.min(1,(event.clientX-rect.left)/rect.width*2-1));
          var y=Math.max(-1,Math.min(1,(event.clientY-rect.top)/rect.height*2-1));
          cancelAnimationFrame(frame);
          frame=requestAnimationFrame(function(){packStage.style.setProperty('--pack-x',x.toFixed(3));packStage.style.setProperty('--pack-y',y.toFixed(3))});
        });
        packStage.addEventListener('pointerleave',function(){packStage.style.removeProperty('--pack-x');packStage.style.removeProperty('--pack-y')});
      }

      var roleCard=q('[data-cala-role-card]');
      function flip(){if(roleCard)roleCard.classList.toggle('is-flipped')}
      if(roleCard)roleCard.addEventListener('click',flip);
      var flipButton=q('[data-cala-flip]');
      if(flipButton)flipButton.addEventListener('click',flip);
      root.querySelectorAll('[data-cala-role]').forEach(function(button){
        button.addEventListener('click',function(){
          root.querySelectorAll('[data-cala-role]').forEach(function(other){var active=other===button;other.classList.toggle('is-active',active);other.setAttribute('aria-pressed',String(active))});
          var image=q('[data-cala-role-image]');
          if(image){image.src=button.dataset.src;image.alt='Carta '+button.dataset.name}
          q('[data-cala-role-name]').textContent=button.dataset.name;
          q('[data-cala-role-side]').textContent=button.dataset.side;
          q('[data-cala-role-copy]').textContent=button.dataset.copy;
          if(roleCard)roleCard.classList.remove('is-flipped');
        });
      });

      var quantity=q('input[name="quantity"]');
      function quantityStep(delta){if(!quantity)return;var min=Number(quantity.min||1),max=Number(quantity.max||99),next=Math.max(min,Math.min(max,Number(quantity.value||min)+delta));quantity.value=String(next);quantity.dispatchEvent(new Event('change',{bubbles:true}))}
      var minus=q('[data-cala-minus]'),plus=q('[data-cala-plus]');
      if(minus)minus.addEventListener('click',function(){quantityStep(-1)});
      if(plus)plus.addEventListener('click',function(){quantityStep(1)});
      var toBuy=q('[data-cala-to-buy]');
      if(toBuy)toBuy.addEventListener('click',function(event){event.preventDefault();q('[data-cala-buy]').scrollIntoView({behavior:reduced.matches?'auto':'smooth',block:'center'})});
      var form=q('form');
      if(form)form.addEventListener('submit',function(event){
        if(location.hash.indexOf('#preview-')===0){event.preventDefault();q('[data-cala-status]').textContent='Anteprima: il gioco verrà aggiunto al carrello nella versione Shopify.'}
      });
    });
  }
  window.CCLCalaInit=init;
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document)});else init(document);
  document.addEventListener('shopify:section:load',function(event){init(event.target)});
})();
